import { render } from "./CommunityItem.vue?vue&type=template&id=564c1232&scoped=true"
import script from "./CommunityItem.vue?vue&type=script&lang=js"
export * from "./CommunityItem.vue?vue&type=script&lang=js"

import "./CommunityItem.vue?vue&type=style&index=0&id=564c1232&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3b689470-9235-485d-ba5a-49630a920e29/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564c1232"]])

export default __exports__